import { rankingItems } from "@/mocks/homeData";

export default function RankingSection() {
  return (
    <section id="ranking" className="px-4 md:px-6 py-14 md:py-20 bg-background-50">
      <div className="max-w-[1400px] mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-xl md:text-3xl font-bold font-heading text-foreground-950">
            热播榜单
          </h2>
          <p className="mt-2 text-sm text-foreground-600">
            根据播放量与搜索热度实时更新，发现大家都在追的好剧
          </p>
        </div>

        <div className="max-w-[800px] mx-auto bg-background-100 rounded-lg border border-background-200/60 overflow-hidden">
          {rankingItems.map((item, idx) => (
            <a
              key={item.rank}
              href="#cards"
              className={`flex items-center gap-4 px-4 md:px-6 py-3.5 transition-colors cursor-pointer hover:bg-background-50 ${
                idx < rankingItems.length - 1 ? "border-b border-background-200/60" : ""
              }`}
            >
              <div className="flex items-center justify-center w-8 h-8 shrink-0">
                {item.rank === 1 ? (
                  <i className="ri-medal-line text-xl text-accent-500" />
                ) : item.rank === 2 ? (
                  <i className="ri-medal-line text-xl text-secondary-400" />
                ) : item.rank === 3 ? (
                  <i className="ri-medal-line text-xl text-amber-600/70" />
                ) : (
                  <span className="text-sm font-bold text-foreground-500">
                    {item.rank}
                  </span>
                )}
              </div>

              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2">
                  <h3 className="text-sm font-semibold text-foreground-950 whitespace-nowrap overflow-hidden text-ellipsis">
                    {item.title}
                  </h3>
                  {item.trend === "up" && (
                    <i className="ri-arrow-up-line text-xs text-accent-500 shrink-0" />
                  )}
                  {item.trend === "stable" && (
                    <i className="ri-subtract-line text-xs text-foreground-500 shrink-0" />
                  )}
                </div>
                <p className="text-xs text-foreground-500 mt-0.5 whitespace-nowrap">
                  {item.genre}
                </p>
              </div>

              <span className="text-xs font-medium text-primary-500 whitespace-nowrap shrink-0">
                {item.hot}
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}